import React from "react";

export default function FormHeader({ title, subtitle }) {
    return (
        <>
            <h1 className="pof-title">{title}</h1>
            <p className="pof-subtitle">{subtitle}</p>
        </>
    );
}
